import Vue from 'vue'

const state = {
    search: '',
    progress: 'all',
    favorite: 'all',
    selected_areas: [],
    selected_groups: []
}

const actions = {
    SET_FILTERS(context, [search, progress, favorite, selected_areas, selected_groups]) {
        context.commit('SAVE_FILTERS', [search, progress, favorite, selected_areas, selected_groups])
    },
}

const mutations = {
    SAVE_FILTERS: (state, [search, progress, favorite, selected_areas, selected_groups]) => {
        Vue.set(state, 'search', search)
        Vue.set(state, 'progress', progress)
        Vue.set(state, 'favorite', favorite)
        Vue.set(state, 'selected_areas', selected_areas)
        Vue.set(state, 'selected_groups', selected_groups)
    }
}

const getters = {
    search: state => {
        return state.search
    },

    progress: state => {
        return state.progress
    },

    favorite: state => {
        return state.favorite
    },

    selected_areas: state => {
        return state.selected_areas
    },

    selected_groups: state => {
        return state.selected_groups
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}